import React from 'react';
import { atlasContent } from '../rich-content/atlas-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const AtlasDetailPage = () => {
  return <AutomaticPageBuilder content={atlasContent} />;
};

export default AtlasDetailPage;
